import {
  ApiFieldValidationErrors,
  ApiValidationError
} from '../models/api-validation.model';


export function normalizeApiValidationError(
  error: unknown
): ApiValidationError {

  // Existing interceptor mostly string return kar raha hai
  if (typeof error === 'string') {
    return {
      message:
        error.trim() ||
        'Something went wrong. Please try again.'
    };
  }

  // Error object format
  if (error && typeof error === 'object') {
    const apiError = error as any;

    return {
      status:
        apiError?.status,

      message:
        getApiValidationMessage(apiError),

      errors:
        getApiFieldValidationErrors(apiError),

      url:
        apiError?.url ?? null
    };
  }

  return {
    message:
      'Something went wrong. Please try again.'
  };
}

function getApiValidationMessage(
  error: any
): string {

  // { message: ['Email required', 'Phone invalid'] }
  if (Array.isArray(error?.message)) {
    return error.message
      .map((message: unknown) => String(message))
      .join(', ');
  }

  // { message: 'Email already exists' }
  if (
    typeof error?.message === 'string' &&
    error.message.trim()
  ) {
    return error.message;
  }

  // { error: { message: 'Invalid request' } }
  if (
    typeof error?.error?.message === 'string' &&
    error.error.message.trim()
  ) {
    return error.error.message;
  }

  // { error: 'Invalid request' }
  if (
    typeof error?.error === 'string' &&
    error.error.trim()
  ) {
    return error.error;
  }

  return 'Something went wrong. Please try again.';
}

function getApiFieldValidationErrors(
  error: any
): ApiFieldValidationErrors | string[] | undefined {

  // Already normalized errors array
  if (Array.isArray(error?.errors)) {
    return error.errors.map(
      (message: unknown) => String(message)
    );
  }

  // Already normalized field errors object
  if (
    error?.errors &&
    typeof error.errors === 'object'
  ) {
    return error.errors as ApiFieldValidationErrors;
  }

  // Backend nested errors array
  if (Array.isArray(error?.error?.errors)) {
    return error.error.errors.map(
      (message: unknown) => String(message)
    );
  }

  // Backend nested field errors object
  if (
    error?.error?.errors &&
    typeof error.error.errors === 'object'
  ) {
    return error.error.errors as ApiFieldValidationErrors;
  }

  // Backend message array
  if (Array.isArray(error?.error?.message)) {
    return error.error.message.map(
      (message: unknown) => String(message)
    );
  }

  return undefined;
}